var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-bar"},_vm._l((_vm.maxRating),function(n){return _c('span',{key:n,staticClass:"star"},[_vm._v("\n        "+_vm._s(n <= _vm.rating ? "★" : "☆")+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }